import { type I18nLocale, t } from '@ardoq/i18n';

export type DashboardFilterNameValidationError = 'tooLong' | 'duplicate';

export type DashboardFilterNameValidationResult =
  | { isValid: true; error: undefined }
  | { isValid: false; error: DashboardFilterNameValidationError };

export const validateDashboardFilterName = (
  name: string,
  existingNames: string[]
): DashboardFilterNameValidationResult => {
  const isDuplicatedName = existingNames.includes(name);
  const isTooLongName = name.length > 50;

  if (isTooLongName) {
    return { isValid: false, error: 'tooLong' };
  }
  if (isDuplicatedName) {
    return { isValid: false, error: 'duplicate' };
  }
  return { isValid: true, error: undefined };
};

export const getValidationErrorMessage = (
  error: DashboardFilterNameValidationError | undefined,
  i18nLocale: I18nLocale
): string | undefined => {
  if (error === 'tooLong') {
    return t(
      i18nLocale,
      'dashboard:filter.validation.tooLong',
      `Name can't be longer than 50 characters`
    );
  }
  if (error === 'duplicate') {
    return t(
      i18nLocale,
      'dashboard:filter.validation.duplicate',
      'Filter name must be unique. This name is already in use.'
    );
  }
  return undefined;
};
